module.exports = __webpack_public_path__ + "static/img/portrait-male.7e57f6df.png";